import {
  Card,
  Row,
  Col,
  Pagination,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import debounce from "lodash/debounce";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import * as API from "../../../../utils/helper/enum";
import globalRequest from "../../../../utils/global/globalRequest";
import {
  formatDateFunction,
  roundToDecimal,
} from "../../../../utils/helper/utils";
import { changeLoader } from "../../../../redux/reducers/loader";
const WalletReports = ({inputData, setInputData, userId }) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [walletHistory, setWalletHistory] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);

  const [filters, setFilters] = useState({
    page: Number(searchParams.get("page")) || 1,
    limit: 10,
    search: searchParams.get("search") || "",
    start_date: searchParams.get("start_date") || null,
    end_date: searchParams.get("end_date") || null,
  });

  useEffect(() => {
    const params = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params[key] = value;
    });
    setSearchParams(params);
  }, [inputData, setInputData]);

  const getWalletBalanceHistory = async () => {
    dispatch(changeLoader(true));
    try {
       let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };

      const res = await globalRequest(
        `${API.MANAGE_REPORT.GET_WALLET_TRANSACTIONS_REPORT}`,
        "GET",
        {},
        { params },
        true
      );

      if (res?.data?.status === "SUCCESS") {
        setWalletHistory(res.data.data.data || []);
        setTotalItems(res.data.data.paginator.itemCount || 0);
      } else toast.error(res?.data?.message);
    } catch (e) {
      toast.error(e.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
      getWalletBalanceHistory();
  }, [ inputData, paginationModel]);


  const searchDebounce = useRef(
    debounce((value) => {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        search: value,
      }));
    }, 500)
  ).current;

  useEffect(() => {
    return () => searchDebounce.cancel();
  }, []);



  const renderTransactionDetails = (item) => {
    if (item?.additionalNote) return item.additionalNote;

    const addedBy =
      userId === item?.addedBy
        ? item?.transactionDetails?.card_number
        : "Admin";

    return item?.transactionDetails?.type === "credit"
      ? `Money added to wallet from ${addedBy}`
      : `Money deducted from wallet by ${addedBy}`;
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card bordered={false}>

            {/* Filters */}
          

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">ID</th>
                    <th className="p-3 text-left">Store Name</th>
                    <th className="p-3 text-left">Transaction Date</th>
                    <th className="p-3 text-left">Type</th>
                    <th className="p-3 text-left">Amount</th>
                    <th className="p-3 text-left">Closing Balance</th>
                    <th className="p-3 text-left">Order Number</th>
                    <th className="p-3 text-left">Distance (KM)</th>
                    <th className="p-3 text-left">Vendor Total Amount</th>
                    <th className="p-3 text-left">Platform Fees</th>
                    <th className="p-3 text-left">Discount</th>
                    <th className="p-3 text-left">Customer Delivery Fees</th>
                    <th className="p-3 text-left">Total Delivery Fees</th>
                    <th className="p-3 text-left">Vendor Deductions</th>
                    <th className="p-3 text-left">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {walletHistory.map((item) => (
                    <tr key={item.id} className="border-b">
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                      <td className="p-3">
                        {item?.vendor?.storeName || "-"}
                      </td>
                     
                      <td className="p-3">
                        {formatDateFunction(item.createdAt, "dd/mm/yyyy", true)}
                      </td>
                       <td className="p-3">
                        {item.transactionDetails?.type}
                      </td>
                      <td
                        className={`p-3 font-semibold ${
                          item.transactionDetails?.type === "credit"
                            ? "text-green-600"
                            : "text-red-500"
                        }`}
                      >
                        {item.transactionDetails?.type !== "credit" && "-"}
                        SAR {item.amount}
                      </td>
                      <td className="p-3">
                        SAR {roundToDecimal(item.walletClosingBalance, 2)}
                      </td>
                      <td className="p-3">
                        {item.orderId && item.transactionDetails?.rhOrderNumber
                          ? `${item.orderId} / ${item.transactionDetails.rhOrderNumber}`
                          : item.orderId ||
                            item.transactionDetails?.rhOrderNumber ||
                            "-"}
                      </td>
                      <td className="p-3">{item.transactionDetails?.distance}</td>
                      <td className="p-3">{item.transactionDetails?.vendorType === "seller" ? item.transactionDetails?.priceDetails?.vendor_total_amount : item.transactionDetails?.priceDetails?.pickup_vendor_total_amount || "-" }</td>
                      <td className="p-3">{item.transactionDetails?.vendorType === "seller" ? item?.transactionDetails?.priceDetails?.platform_fees : item?.transactionDetails?.priceDetails?.pickup_platform_fees || "-"}</td>
                      <td className="p-3">{roundToDecimal(item.transactionDetails?.priceDetails?.pickup_discount + item.transactionDetails?.priceDetails?.timeslot_discount + item.transactionDetails?.priceDetails?.coupon_discount, 2) || "-" }</td>
                      <td className="p-3">{item.transactionDetails?.priceDetails?.delivery_fees || "-"}</td>
                      <td className="p-3">{item?.transactionDetails?.priceDetails?.total_delivery_fees || "-"}</td>
                      <td className="p-3">{item?.transactionDetails?.deductionDetails?.vendor_deduction || item?.transactionDetails?.deductionDetails?.pickupvendor_deduction || "-"}</td>
                      <td className="p-3">
                        {renderTransactionDetails(item)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalItems > 0 && (
              <div className="flex justify-end mt-4">
                <Pagination
                    defaultCurrent={1}
                    total={totalItems}
                    pageSizeOptions={paginationPages}
                    showSizeChanger={true}
                    current={paginationModel?.page}
                    pageSize={paginationModel?.limit}
                    onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
                    onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
                />
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default WalletReports;
